'use client';

import React from 'react';
import { Pin, X } from 'lucide-react';
import { Message } from './types';

interface PinnedMessageBannerProps {
  message: Message;
  onUnpin: () => void;
  onScrollToMessage: () => void;
}

export default function PinnedMessageBanner({ message, onUnpin, onScrollToMessage }: PinnedMessageBannerProps) {
  const preview = message.text
    ? message.text.length > 60
      ? message.text.slice(0, 60) + '…'
      : message.text
    : message.imageUrl
    ? '📷 Photo'
    : message.audioUrl
    ? '🎤 Voice message'
    : message.fileUrl
    ? `📎 ${message.fileName ?? 'File'}`
    : 'Message';

  return (
    <div
      className="flex items-center gap-2 px-3 py-2 flex-shrink-0 cursor-pointer select-none"
      style={{
        background: 'rgba(40, 127, 216, 0.12)',
        borderBottom: '1px solid rgba(40, 127, 216, 0.2)',
        minHeight: '44px',
      }}
      onClick={onScrollToMessage}
      role="button"
      aria-label="Jump to pinned message"
    >
      {/* Pin icon */}
      <div className="flex-shrink-0 flex items-center justify-center w-7 h-7 rounded-full" style={{ background: 'rgba(40, 127, 216, 0.2)' }}>
        <Pin size={13} className="text-blue-400" style={{ transform: 'rotate(45deg)' }} />
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0">
        <p className="text-[11px] font-semibold text-blue-400 leading-none mb-0.5">Pinned Message</p>
        <p className="text-[13px] text-white/80 leading-tight truncate">{preview}</p>
      </div>

      {/* Unpin button */}
      <button
        onClick={(e) => { e.stopPropagation(); onUnpin(); }}
        className="flex-shrink-0 flex items-center justify-center w-7 h-7 rounded-full hover:bg-white/10 transition-colors duration-150"
        aria-label="Unpin message"
        title="Unpin message"
      >
        <X size={14} className="text-white/50" />
      </button>
    </div>
  );
}
